module.exports = __webpack_public_path__ + "static/media/vertex.58cfbfdb.svg";